/** Utility exports - re-export commonly used utilities. */

import { createContext, type Context } from "react";

export { cn } from "./utils/cn";
export { errorFromResponse, userFriendlyMessage, isRetryableError } from "./utils/response";
export { getLogger } from "./utils/logger";
export { dateToISO, dateToLocal, dateTimeToLocal, numberWithCommas, percentageString, durationString } from "./utils/format";
export { isSuccessResponse, isErrorResponse, dataFromResponse, itemsFromPaginated, itemsFromList, paginationFromResponse, parsePaginationMeta, totalPagesFromOffsetPayload } from "./utils/response";

/** Pin Context on globalThis so HMR/lazy re-imports keep one Provider identity. */
export function createSharedContext<T>(key: string, defaultValue: T): Context<T> {
  const g = globalThis as typeof globalThis & Record<string, Context<T> | undefined>;
  const existing = g[key];
  if (existing) return existing;
  const created = createContext(defaultValue);
  g[key] = created;
  return created;
}
